export enum EntitiesTypes {
  BRAND = "brand",
  ORGANISATION = "organisation"
}

export enum ClientTaxTypes {
  BRAND_INHERIT = 0,
  ZERO_TAX = 1,
  NO_TAX = 2
}

/**
 * let say we have product 100 net + 20 % brand tax = 120
 * in 0 - price is 100
 * in 1 price is 120 but on order time if client use 23% tax can change to 123
 * in 2 we keep 120 even in case on client using 23%
 */
export enum BrandTaxTypes {
  EXCLUDE_TAX = 0,
  INCLUDE_TAX_RESPECT_CLIENT_TAX = 1,
  INCLUDE_TAX_IGNORE_CLIENT_TAX = 2
}
